import { Asset } from '@api/models'
import { KIA_APP_COMPANY_ID, KIA_ASSET_COMPANY_ID } from '@constants'

/**
 * Reads the current organization's AppCompanyID from the persisted user.
 * `store/actions/user.ts` writes `appCompanyID` onto the `currentUser`
 * localStorage entry at login. Returns undefined if unavailable.
 */
function getCurrentAppCompanyID(): number | undefined {
  try {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'))
    return currentUser?.appCompanyID
  } catch {
    return undefined
  }
}

/**
 * True when the asset belongs to the Kia asset company (200) and the current
 * org is the Kia org (AppCompanyID 13). If the org id is not available in
 * localStorage, falls back to the asset company check alone.
 */
export function isKiaCompany(asset: Asset): boolean {
  if (asset?.AssetCompanyID !== KIA_ASSET_COMPANY_ID) {
    return false
  }

  const appCompanyID = getCurrentAppCompanyID()

  if (appCompanyID === undefined || appCompanyID === null) {
    return true
  }

  return appCompanyID === KIA_APP_COMPANY_ID
}
